import {FederationUserInfo, UserProfile} from "@/shared/domain/User";
import {Component, Vue} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import AuthenticatedUserMixin from "@/components/AuthenticatedUserMixin";

@Component
export class CompetitionPermissionHelper extends mixins(AuthenticatedUserMixin, Vue) {
}
